"use strict";

module.exports = function (str, searchStr) {
    return str.indexOf(searchStr) >= 0;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/string-contains/index.js
 ** module id = 422
 ** module chunks = 0
 **/